import { render, staticRenderFns } from "./Signed.vue?vue&type=template&id=37ec839e&"
import script from "./Signed.vue?vue&type=script&lang=js&"
export * from "./Signed.vue?vue&type=script&lang=js&"
import style0 from "./Signed.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports